import React, { Component, useContext } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import AdminReferenceData from "./Admin/AdminReferenceData";
import SystemLog from './Admin/SystemLog';
import Template from './Admin/Template';
import Templates from './Admin/Templates';
import ApiKeys from './Admin/ApiKeys/ApiKeys';
import OverdueSalesEmails from './Admin/OverdueSalesEmails/OverdueSalesEmails';
import ScheduleView from "./Admin/Users/ScheduleView";
import User from './Admin/Users/User';
import Users from './Admin/Users/Users';
import UserSchedule from "./Admin/Users/UserSchedule";
import AuthContext from './auth-context';
import Contacts from './Contacts/Contacts';
import ContactShow from "./Contacts/Show";
import Dashboard from "./Dashboard/Dashboard";
import Deals from './Deals/Deals';
import DealShow from "./Deals/Show";
import LeadsListView from "./Leads/ListView";
import LeadsShow from "./Leads/Show";
import Navbar from "./MainNavbar";
import Reporting from './Reporting/Reporting';
import SeminarCreate from "./Seminars/Create";
import SeminarEdit from "./Seminars/Edit";
import SeminarsListView from "./Seminars/ListView";
import SeminarShow from "./Seminars/Show";
import Dialer from './Shared/Dialer';
import TCSCalendarView from "./TCS/TCSCalendarView";
import TCSListView from "./TCS/TCSListView";
import TestPage from "./Test/TestPage";
import CallRecords from './Voice/CallRecords';
import ConfirmationDashboardListView from "./ConfirmationDashboard/ConfirmationDashboardListView";
import SalesPersonTasks from "./SalesPersonTasks/Index";

const RestrictedRoute = ({ onlyAllow, dontAllow, ...props }) => {
  const authStore = useContext(AuthContext)

  let isAllowed = true
  if (onlyAllow) {
    isAllowed = onlyAllow.some(element => authStore.hasRole(element))
  }
  if (dontAllow) {
    if (dontAllow.some(element => authStore.hasRole(element))) isAllowed = false
  }

  return isAllowed
    ? <Route {...props} />
    : <Redirect to="/login" />;
}

class MainLayout extends Component {
  static contextType = AuthContext;

  render() {
   const authStore = this.context

    const isVoiceEnabled = authStore.hasRole('voice_enabled')
    return (
      <div className="container-fluid">
        <div className="row">
          <Navbar></Navbar>
        </div>

        {isVoiceEnabled && <Dialer />}

        <Switch>
          <Route path="/m1/test" render={(props) => <TestPage {...props} />} />
          <Route
            path="/m1/dashboard"
            render={(props) => <Dashboard {...props} />}
          />
          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/admin/api-keys"
            render={(props) => <ApiKeys {...props} />}
          />
          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/admin/overdue-sales-emails"
            render={(props) => <OverdueSalesEmails {...props} />}
          />
          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/admin/systemlog"
            render={(props) => <SystemLog {...props} />}
          />
          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/admin/bookings"
            render={(props) => (
              <AdminReferenceData title="Bookings" type="bookings" {...props} />
            )}
          />
          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/admin/holidays"
            render={(props) => (
              <AdminReferenceData title="Holidays" type="holidays" {...props} />
            )}
          />
          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/admin/templates/:id"
            render={(props) => (
              <Template title="Templates" type="templates" {...props} />
            )}
          />
          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/admin/templates"
            render={(props) => (
              <Templates title="Templates" type="templates" {...props} />
            )}
          />
          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/admin/users"
            render={(props) => (
              <AdminReferenceData title="Users" type="users" {...props} />
            )}
          />
          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/admin/leadmachine"
            render={(props) => (
              <AdminReferenceData
                title="LeadMachine Integration"
                type="leadmachine"
                {...props}
              />
            )}
          />
          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/admin/messaging"
            render={(props) => (
              <AdminReferenceData
                title="Messaging"
                type="messaging"
                {...props}
              />
            )}
          />
          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/admin/prompts"
            render={props => (
              <AdminReferenceData
                title="Sales Person Ai Analysis Prompts"
                type="ai_sales_report"
                {...props}
              />
            )}
          />
          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/admin/integrations"
            render={(props) => (
              <AdminReferenceData
                title="Integrations"
                type="integrations"
                {...props}
              />
            )}
          />

          <RestrictedRoute
            dontAllow={["coach_restricted"]}
            path="/m1/deals/list/:view"
            render={(props) => <Deals {...props} />}
          />

          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/users/schedules"
            exact
            render={(props) => <ScheduleView {...props} />}
          />

          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/users/:id"
            exact
            render={(props) => <User {...props} />}
          />

          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/users/:id/schedule"
            exact
            render={(props) => <UserSchedule {...props} />}
          />

          <RestrictedRoute
            onlyAllow={["admin"]}
            path="/m1/users"
            render={(props) => <Users {...props} />}
          />

          <Route
            path="/m1/deals/:id"
            render={(props) => <DealShow {...props} />}
          />

          <RestrictedRoute
            path="/m1/reporting/:view"
            render={(props) => <Reporting {...props} />}
          />

          <RestrictedRoute
            dontAllow={["coach_restricted"]}
            path="/m1/seminars/new"
            render={(props) => <SeminarCreate {...props} />}
          />
          <RestrictedRoute
            dontAllow={["coach_restricted"]}
            path="/m1/seminars/:id/edit"
            render={(props) => <SeminarEdit {...props} />}
          />

          <RestrictedRoute
            dontAllow={["coach_restricted"]}
            path="/m1/seminars/:id/registrations/:view"
            render={(props) => <SeminarShow {...props} />}
          />

          <RestrictedRoute
            dontAllow={["coach_restricted"]}
            path="/m1/seminars/"
            render={(props) => <SeminarsListView {...props} />}
          />

          <RestrictedRoute
            exact
            path="/m1/follow_ups/:id"
            render={(props) => <LeadsShow {...props} />}
          />

          <RestrictedRoute
            path="/m1/follow_ups/list/:view"
            render={(props) => <LeadsListView {...props} />}
          />

          <Route
            path="/m1/tcs/list/:view"
            render={(props) => <TCSListView {...props} />}
          />
          <Route
            path="/m1/tcs/calendar"
            render={(props) => <TCSCalendarView {...props} />}
          />
          <Route
            path="/m1/confirmation_dashboard/list/:view"
            render={(props) => <ConfirmationDashboardListView {...props} />}
          />
          <Route
            path="/m1/call_records/list/:view"
            render={(props) => <CallRecords {...props} />}
          />

          <Route
            path="/m1/contacts/list/:view"
            render={(props) => <Contacts {...props} />}
          />
          <Route
            path="/m1/contacts/:id"
            render={(props) => <ContactShow {...props} />}
          />
          
          <Route
            path="/m1/sales_person_tasks"
            render={(props) => <SalesPersonTasks {...props} />}
          />
        </Switch>
    </div>
    );
  }
}
export default MainLayout